import { useCallback } from 'react'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useRepoStringsSuggestions() {
  const { state, dispatch } = useAppContext()
  
  const addRepoStringSuggestion = useCallback((repository, bugIndex, stringIndex) => {
    dispatch({
      type: actionTypes.ADD_REPO_STRING_SUGGESTION,
      repository,
      bugIndex,
      stringIndex
    })
  }, [dispatch])
  
  const removeRepoStringSuggestion = useCallback((bugIndex, stringIndex) => {
    dispatch({
      type: actionTypes.REMOVE_REPO_STRING_SUGGESTION,
      bugIndex,
      stringIndex
    })
  }, [dispatch])
  
  const resetRepoStringsSuggestions = useCallback(() => {
    dispatch({ type: actionTypes.RESET_REPO_STRINGS_SUGGESTIONS })
  }, [dispatch])
  
  return {
    repoStringsSuggestions: state.repoStringsSuggestions,
    addRepoStringSuggestion,
    removeRepoStringSuggestion,
    resetRepoStringsSuggestions
  }
}
